import { render, staticRenderFns } from "./ArticleModalContent.vue?vue&type=template&id=add748f8&scoped=true"
import script from "./ArticleModalContent.vue?vue&type=script&lang=js"
export * from "./ArticleModalContent.vue?vue&type=script&lang=js"
import style0 from "./ArticleModalContent.vue?vue&type=style&index=0&id=add748f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add748f8",
  null
  
)

export default component.exports